// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1AojQMyWGFhMo6ZQeOIVg-","text":"H-Hcb6uCCAtr9mmqGYOAd","copy":"_36uwPJ6syOeoJ4LHyuxkUf","twitter":"_3rdTsLDeq13VMM7NP9jdyw","facebook":"_13q4aC2ZGcBYMy_0sWk2pf"};